import { useUser } from '../hooks/useUser'
import Loader from '../components/layouts/Loader'
import { Navigate } from 'react-router-dom'

export default function RequiredRegistrationRoute({ children }) {
  const { user, isLoading } = useUser()
  const { firstName } = user

  if (isLoading) {
    return <Loader />
  }

  if (!firstName) {
    return <Navigate to="/register/profile" />
  }

  return children
}
